import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/lib/Modal';
import Button from './Button';

export default class SelectionModal extends React.Component {
  static propTypes = {
    children: PropTypes.any,
    canClose: PropTypes.bool,
    onClose: PropTypes.func,
    title: PropTypes.string,
    id: PropTypes.string,
    show: PropTypes.bool,
    selectionMade: PropTypes.string,
    footerCloseButton: PropTypes.shape({
      isTurnedOn: PropTypes.bool,
      text: PropTypes.string
    })
  };

  static defaultProps = {
    show: true,
    closeButton: true
  };

  renderFooter() {
    const { footerCloseButton } = this.props;

    if (footerCloseButton) {
      const { isTurnedOn, text } = footerCloseButton;

      if (isTurnedOn) {
        return (
          <Modal.Footer>
            <Button
              style="primary"
              disabled={!this.props.selectionMade}
              onClick={() => this.props.onClose(false)}
              label={text || "Cancel"}
            />
          </Modal.Footer>
        )
      }
    }
  }

  render() {
    let { onClose, id, canClose, show, title } = this.props;
    return (
      <Modal id={id} className="selectionModal" show={show} onHide={() => onClose(true)} keyboard={canClose} backdrop={canClose ? true : 'static'}>
        <Modal.Header closeButton={true}>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.props.children}
        </Modal.Body>
        {this.renderFooter()}
      </Modal>
    );
  }
}
